import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(dynamic)/class-assist/[industry]/[sector]/ClassAssistIndustrySector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
